import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

type ImageProps = {
    content?: {
        height?: number;
        intranetUrl?: string;
        key?: string;
        size?: number;
        url?: string;
        width?: number;
        duration?: number;
        fileSize?: number;
        thumbnail?: string;
    };
};

const Image = ({ content }: ImageProps) => {
    let imageUrl = content?.url || '';

    if (content?.height && content?.width) {
        // 等比裁图
        const imageHeight = Math.floor((content.height * 670) / content.width);

        imageUrl = formatImageWebpAuto(content?.url, 670, imageHeight, 85);
    }

    return content?.url ? (
        <div className={styles.articleonePic}>
            <LazyImg className={styles.onePicImg} src={imageUrl} />
        </div>
    ) : null;
};

export default errorBoundary(Image);
